import { render, staticRenderFns } from "./wallet-box1.vue?vue&type=template&id=33094e78&scoped=true&"
import script from "./wallet-box1.vue?vue&type=script&lang=js&"
export * from "./wallet-box1.vue?vue&type=script&lang=js&"
import style0 from "./wallet-box1.vue?vue&type=style&index=0&id=33094e78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33094e78",
  null
  
)

export default component.exports